import { Fragment, useState, useEffect } from 'react';
import { Dialog, Transition } from '@headlessui/react'
import { toast } from "react-hot-toast";
import HelperService from '../../../utility/HelperService';
import { CgClose } from 'react-icons/cg';
import { Label } from '../../../components/Label/Label';
import { useForm } from "react-hook-form";

const ArcheivedGoalsPopUp = (props: any) => {

    // const {
    //     register,
    //     handleSubmit,
    //     reset,
    //     control,
    //     setValue,
    //     formState: { errors },
    // } = useForm();
    return (<>
    <Transition.Root show={props.open2} as={Fragment}>
        <Dialog as="div" className="relative z-10" initialFocus={props.cancelButtonRef} onClose={props.setOpen2}>
            <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
            >
                <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>

            <div className="fixed inset-0 z-10 overflow-y-auto">
                <form onSubmit={props.handleSubmit(props.DeleteReason)}>
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                            <Dialog.Panel className="relative transform  rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-md sm:p-6">
                                <div>

                                    <div className="">
                                        <Dialog.Title as="h3" className="text-xl font-semibold leading-6   mb-4 text-center">
                                            Goal : {props.deletedData.value}
                                        </Dialog.Title>

                                    </div>
                                    <div className="form-style">
                                        <div className="mb-2">
                                            <div className="">
                                                {(props.isMapped) &&
                                                <p style={{color:'#b94a48'}}>Assets are mapped for this goal. If you proceed, all assets will be unmapped for this goal and it will be archived.</p>
                                                }
                                                <label className=" mb-0 mr-4">Please mention the reason for deletion : <span className=" text-red-600">*</span></label>
                                                <div className="flex mt-3">
                                                    <div className="flex items-center">
                                                        <input
                                                            id="Goal is achieved"
                                                            type="radio"
                                                            value={'Goal is achieved'}
                                                            className="custom-radio"
                                                            {...props.register("reason", {
                                                                required: true,
                                                            })}
                                                        />
                                                        <label htmlFor="Goal is achieved" className="block text-sm font-medium text-gray-700">Goal is achieved</label>
                                                    </div>
                                                    <div className="flex items-center">
                                                        <input
                                                            id="Goal is canceled"
                                                            type="radio"
                                                            value={'Goal is canceled'}
                                                            className="custom-radio"
                                                            {...props.register("reason", {
                                                                required: true,
                                                            })}
                                                        />
                                                        <label htmlFor="Goal is canceled" className="ml-3 block text-sm font-medium text-gray-700">Goal is canceled</label>
                                                    </div>
                                                </div>
                                                <div>
                                                    {props.errors.reason && (
                                                        <Label title={"Please Select Reason for deletion."} modeError={true} />
                                                    )}
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div className="mt-5 flex justify-center">
                                    <button
                                        type="button"
                                        className="btn btn-brand-outline mr-3 w-32"
                                        onClick={() => {
                                            props.setOpen2(false)
                                            props.setDeletedData('')
                                        }
                                        }
                                    >Cancel</button>
                                    <button
                                        type="submit"
                                        className="btn btn-brand w-32"
                                        ref={props.cancelButtonRef}
                                    >
                                        Save
                                    </button>
                                </div>

                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </form>
            </div>
        </Dialog>
    </Transition.Root>
    </>);
}
export default ArcheivedGoalsPopUp;
